export const EventsEnum = {
  UPDATE_MEASUREMENT: "updateMeasurement",
  VERTEBRA_SELECTION: "vertebraSelection",
  MANUAL_OSTEOTOMY_TOOL_UPDATE: "manualOsteotomyToolUpdate",
  GET_MEASUREMENTS: "getMeasurements",
  MANUAL_SEGMENTAL_TRANSFORMATION_TOOL_UPDATE:
    "manualSegmentalTransformationToolUpdate",
  MANUAL_CAGE_TOOL_UPDATE: "manualCageToolUpdate",

  START_MOUSE_TRACKING: "startMouseTracking",
  END_MOUSE_TRACKING: "endMouseTracking",
  MOUSE_POSITION_UPDATE: "mousePositionUpdate",
  TRACK_MOUSE: "trackMouse",
  TOGGLE_LOADING: "toggleLoading",
  SHOW_SAGITTAL_ADVANCED_MEASUREMENT: "showSagittalAdvancedMeasurement",
  SHOW_CORONAL_ADVANCED_MEASUREMENT: "showCoronalAdvancedMeasurement",

  UPDATE_VIEWS: "updateViews",
  RADIO_DENSITY_VERTEBRA_SELECTED: "radioDensityVertebraSelected",
  DRR_VALIDATION_POINT_ADDED: "drrValidationPointAdded",
};
